import { createSystem, defaultConfig } from '@chakra-ui/react'

export const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      colors: {
        brand: {
          // Generated with colorPalette.ts from #065F46
          50: { value: '#f3fcf9' },
          100: { value: '#e2f8f2' },
          200: { value: '#c6f5e8' },
          300: { value: '#7ff0d0' },
          400: { value: '#12cc98' },
          500: { value: '#065F46' },
          600: { value: '#064b38' },
          700: { value: '#063b2c' },
          800: { value: '#062c22' },
          900: { value: '#06221a' },
          950: { value: '#061813' },
        },
        sidebar: {
          bg: { value: '#ffffff' },
          hover: { value: '#f7f7f7' },
          active: { value: '#f0f0f0' },
        },
      },
      fonts: {
        heading: { value: 'Manrope Variable, system-ui, sans-serif' },
        body: { value: 'Inter, system-ui, sans-serif' },
      },
      shadows: {
        brand: { value: '0 4px 14px 0 rgba(102, 97, 93, 0.15)' },
      },
    },
  },
})